module.exports = __webpack_public_path__ + "static/media/H9986_2025 Sales Presentation V2_10_8_24.31139ea9.pdf";